
import * as constants from "../../constants";
class MarketerBaseService {
    static getPostingType() {
        return new Promise((resolve, reject) => {
            const fd = new FormData();
            fd.append("command", "get_posting_type");

            const xhttp = new XMLHttpRequest();

            xhttp.onreadystatechange = () => {
                if (xhttp.readyState === 4) {
                    if (xhttp.status === 200) {
                        const res = JSON.parse(xhttp.responseText);

                        if (res.result === "ok") {
                            resolve(res.data.map(item => ({
                                value: item.posting_type_id,
                                label: item.posting_type_name,
                            })));
                        } else {
                            reject(res.desc);
                        }
                    } else {
                        reject("خطا در ارتباط با سرور");
                    }
                }
            };

            xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
            xhttp.send(fd);
        });
    }
    static getPeymentType() {
        return new Promise((resolve, reject) => {
            const fd = new FormData();
            fd.append("command", "get_peyment_type");

            const xhttp = new XMLHttpRequest();

            xhttp.onreadystatechange = () => {
                if (xhttp.readyState === 4) {
                    if (xhttp.status === 200) {
                        const res = JSON.parse(xhttp.responseText);

                        if (res.result === "ok") {
                            resolve(res.data.map(item => ({
                                value: item.payment_type_id,
                                label: item.payment_type_name,
                            })));
                        } else {
                            reject(res.desc);
                        }
                    } else {
                        reject("خطا در ارتباط با سرور");
                    }
                }
            };

            xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
            xhttp.send(fd);
        });
    }
    static getVisitType() {
        return new Promise((resolve, reject) => {
            const fd = new FormData();
            fd.append("command", "get_visit_type");

            const xhttp = new XMLHttpRequest();

            xhttp.onreadystatechange = () => {
                if (xhttp.readyState === 4) {
                    if (xhttp.status === 200) {
                        const res = JSON.parse(xhttp.responseText);

                        if (res.result === "ok") {
                            resolve(res.data.map(item => ({
                                value: item.visit_type_id,
                                label: item.visit_type_name,
                            })));
                        } else {
                            reject(res.desc);
                        }
                    } else {
                        reject("خطا در ارتباط با سرور");
                    }
                }
            };

            xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
            xhttp.send(fd);
        });
    }
    static getCompany() {
        return new Promise((resolve, reject) => {
            const fd = new FormData();
            fd.append("command", "get_company");
            fd.append("fieldinsurance", "thirdpartyins");


            const xhttp = new XMLHttpRequest();

            xhttp.onreadystatechange = () => {
                if (xhttp.readyState === 4) {
                    if (xhttp.status === 200) {
                        const res = JSON.parse(xhttp.responseText);

                        if (res.result === "ok") {
                            resolve(res.data.map(item => ({
                                value: item.company_id,
                                label: item.company_name,
                                logo: item.company_logo_url,
                            })));
                        } else {
                            reject(res.desc);
                        }
                    } else {
                        reject("خطا در ارتباط با سرور");
                    }
                }
            };

            xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
            xhttp.send(fd);
        });
    }
}

export default MarketerBaseService;
